import style from "css/hotdesking.module.css";
import React, { useLayoutEffect, useState } from "react";
import SearchMenu from "./SearchMenu";
import SearchContent from "./SearchContent";

function Search({
  date,
  setDate,
  time,
  setTime,
  location,
  setLocation,
  departmentId,
  isFind,
  setIsFind,
  onShowBook,
  serverDate,
  workTime,
  setDefaultLocation,
}) {
  const [view, setView] = useState("today");

  useLayoutEffect(() => {
    if (isFind && view !== "today") {
      setView("today");
    }
  }, [isFind, view]);

  const onChangeView = (key) => {
    setView(key);
  };

  return (
    <section className={style.search_section}>
      <SearchMenu view={view} onChange={onChangeView} />
      <SearchContent
        view={view}
        date={date}
        setDate={setDate}
        time={time}
        setTime={setTime}
        location={location}
        setLocation={setLocation}
        departmentId={departmentId}
        isFind={isFind}
        setIsFind={setIsFind}
        onShowBook={onShowBook}
        serverDate={serverDate}
        workTime={workTime}
        setDefaultLocation={setDefaultLocation}
      />
    </section>
  );
}

export default Search;
